/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSignedFileUrlQueryResponse2
 */
export interface GetSignedFileUrlQueryResponse2 {
    /**
     * Signed url
     * @type {string}
     * @memberof GetSignedFileUrlQueryResponse2
     */
    url: string;
}

/**
 * Check if a given object implements the GetSignedFileUrlQueryResponse2 interface.
 */
export function instanceOfGetSignedFileUrlQueryResponse2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function GetSignedFileUrlQueryResponse2FromJSON(json: any): GetSignedFileUrlQueryResponse2 {
    return GetSignedFileUrlQueryResponse2FromJSONTyped(json, false);
}

export function GetSignedFileUrlQueryResponse2FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSignedFileUrlQueryResponse2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function GetSignedFileUrlQueryResponse2ToJSON(value?: GetSignedFileUrlQueryResponse2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

